"use client"
import React, { useState } from "react"
import Image, { ImageProps } from "next/image"
import { Loader2 } from "lucide-react"

/**
 * NFTImage component props
 * @extends ImageProps
 */
interface NFTImageProps extends ImageProps {
  /**
   * Optional CSS class name for the container
   */
  containerClassName?: string
}

/**
 * NFTImage component
 *
 * Renders an image with a loading spinner until the image is fully loaded.
 * Uses Next.js Image component for optimized image loading.
 *
 * @param props - The component props
 * @returns The NFTImage component
 */
const NFTImage: React.FC<NFTImageProps> = ({
  containerClassName,
  ...props
}) => {
  const [isLoading, setIsLoading] = useState(true)

  return (
    <div className={`relative ${containerClassName || ""}`}>
      {isLoading && (
        <div className="absolute inset-0 flex items-center justify-center">
          <Loader2 className="animate-spin h-6 w-6 text-slate-600" />
        </div>
      )}
      <Image
        {...props}
        priority
        onLoad={() => setIsLoading(false)}
        className={`${props.className || ""} ${isLoading ? "invisible" : "visible"}`}
      />
    </div>
  )
}

export default NFTImage
